import { render, staticRenderFns } from "./SupplyChainList.vue?vue&type=template&id=2dbc25b0&scoped=true&"
import script from "./SupplyChainList.vue?vue&type=script&lang=js&"
export * from "./SupplyChainList.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainList.vue?vue&type=style&index=0&id=2dbc25b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc25b0",
  null
  
)

export default component.exports